import { styled } from "@mui/material/styles";

export const FloatingButton = styled("button")({
    position: "fixed",
    right: 24,
    bottom: 24,
    zIndex: 14000,
    background: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: 24,
    padding: "12px 20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 500,
    transition: "background 0.2s",
    "&:hover": {
        background: "#1565c0",
    },
});
